import $ from 'jquery';

window.$ = $;

import foundation from 'foundation-sites';

$(document).foundation();
